import styled from 'styled-components';
import { ReactComponent as FolderIcon } from 'Images/empty-folder.svg';

export const Badge = styled.div`
  display: inline-flex;
  align-items: stretch;
  height: 24px;
  max-width: 340px;
  border-radius: 2px;
  overflow: hidden;

  border: 1px solid #d7dee7;
  background: #eef2f6;
  color: #5b6675;

  user-select: none;
  margin-left: 6px;
  cursor: pointer;
`;
Badge.displayName = 'Badge';

export const BadgeLeft = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;

  background: #eef2f6;
  color: #5b6675;

  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2px;
  text-transform: uppercase;
`;
BadgeLeft.displayName = 'BadgeLeft';

export const BadgeRight = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  min-width: 0;
  max-width: 230px;

  background: #5b6675;
  color: #ffffff;

  font-size: 12px;
  font-weight: 700;
`;
BadgeRight.displayName = 'BadgeRight';

export const SinglePill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  max-width: 280px;
  min-width: 0;
  border-radius: 2px;

  background: #eef2f6;
  border: 1px solid #d7dee7;
  color: #5b6675;

  user-select: none;
  margin-left: 6px;
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
`;
SinglePill.displayName = 'SinglePill';

export const Icon = styled(FolderIcon)`
  width: 14px;
  height: 14px;
  opacity: 0.9;
  & path { fill: currentColor !important; }
`;
Icon.displayName = 'Icon';

export const Text = styled.span`
  display: inline-block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
`;
Text.displayName = 'Text';
